import React, { useRef, useEffect, useState } from "react"
import styled from "styled-components"
import SlickSlider from 'react-slick'
import AnimationCount from 'react-count-animation'
import { TemplateApis } from '@/utils/Videomonster/Api';
import i18n from "@/i18n"
import { useSelector } from 'react-redux';

const CardWrapper = styled.article`
    border-radius: 4px;
    background-color: #f1f1f1;
    position: relative;
    display: flex;
    min-height: 84px;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
`

const Title = styled.h3`
    color: #515151;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: -0.34px;
    z-index: 0;
`

const ValueContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 6px;
`

const Value = styled.span`
    color: #83c308;
    font-size: 28px;
    font-weight: 900;
    letter-spacing: -0.56px;
    z-index: 0;
`

const CountWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: auto;
    color: #83c308;
    font-size: 28px;
    font-weight: 900;
    letter-spacing: -0.56px;
    z-index: 0;
    > div {
        color: #83c308;
    }
    > span {
        color: #83c308;
        margin-top: -4px;
    }
`

const Suffix = styled.span`
    color: #83c308;
    font-size: 16px;
    font-weight: 900;
    letter-spacing: -0.32px;
    position: absolute;
    z-index: 0;
    width: 12px;
    height: 21px;
`
const Section = styled.section`
    margin-top: 100px;
    background-color: #fff;
    display: flex;
    width: 900px;
    max-width: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    font-weight: 800;
    justify-content: center;
    padding: 0 20px 32px;
`

const ContentWrapper = styled.div`
    display: flex;
    max-width: 100%;
    align-items: center;
    gap: 40px 79px;
    justify-content: space-between;
    flex-wrap: wrap;
`

const Content = styled.div`
    align-self: stretch;
    display: flex;
    min-width: 240px;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    width: 450px;
    margin: auto 0;
`

const BadgeWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Badge = styled.span`
    align-self: stretch;
    width: 160px;
    border-radius: 789px;
    background-color: #222;
    max-width: 100%;
    font-size: 22px;
    color: #fff;
    text-align: center;
    letter-spacing: -0.44px;
    line-height: 1;
    padding: 8px 2px;
    font-weight: 700;
`

const TitleGroup = styled.div`
    display: flex;
    margin-top: 20px;
    width: 100%;
    flex-direction: column;
    align-items: center;
    text-align: center;
`

const CategoryWrapper = styled.span`
    display: flex;
    align-items: center;
    font-size: 28px;
    white-space: nowrap;
    letter-spacing: -0.56px;
    line-height: 1;
    justify-content: center;
`

const BracketText = styled.span`
    color: #515151;
    align-self: stretch;
    margin: auto 0;
    padding: 0 3px;
`

const CategoryText = styled.span`
    background: linear-gradient(#34FFEB, #450099);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 34px;
    letter-spacing: -0.68px;
    align-self: stretch;
    margin: auto 0;
`

const SlickWrapper = styled.div`
  width: 92px;
  overflow: hidden;

  &.en {
	width: 180px;
  }

  &.jp {
	width: 112px;
  }

  .slick-track {
    display: block;
    align-items: inherit;
  }

  .slick-item {
    font-family: "NEXON Lv1 Gothic";
    font-size: 50px;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
  }
`;

const ServiceTitle = styled.span`
    display: inline-block;
    color: #515151;
    font-size: 34px;
    line-height: 1;
    letter-spacing: -0.68px;
    padding-left: 8px;
`

const BrandName = styled.h2`
    display: inline-block;
    color: #83c308;
    font-size: 34px;
    line-height: 1;
    letter-spacing: -0.68px;
    margin-top: 8px;
`

const StatsContainer = styled.div`
    display: flex;
    margin-top: 20px;
    width: 289px;
    max-width: 100%;
    flex-direction: column;
    gap: 6px;
`

const TopStats = styled.div`
    display: flex;
    gap: 6px;
    width: 100%;
`

const DeviceWrapper = styled.div`
    position: relative;
    aspect-ratio: 0.49;
    object-position: center;
    width: 233px;
    align-self: stretch;
    margin: auto 0;
`

const Video = styled.video`
    position: absolute;
    top: 0;
    left: 0;

    aspect-ratio: 0.49;
    object-fit: cover;
    object-position: center;
    width: 233px;
    align-self: stretch;
    margin: auto 0;
    z-index: 0;
    padding: 11px;
`

const Image = styled.img`
    position: absolute;
    top: 0;
    left: 0;

    aspect-ratio: 0.49;
    object-fit: contain;
    object-position: center;
    width: 233px;
    align-self: stretch;
    margin: auto 0;
    z-index: 1;
`

const ButtonContainer = styled.section`
    margin-top: 32px;
    background: #fff;
    display: flex;
    width: 900px;
    max-width: 100%;
    flex-direction: row;
    overflow: hidden;
    align-items: center;
    color: #fff;
    text-align: center;
    letter-spacing: -0.4px;
    justify-content: center;
    padding: 0 20px 40px;
`

const StartButton = styled.button`
    align-self: stretch;
    border-radius: 8px;
    background: #222;
    min-height: 60px;
    width: 760px;
    max-width: 100%;
    border: none;
    color: inherit;
    font: inherit;
    cursor: pointer;
    padding: 17px 10px;
    font-weight: 700;
    font-size: 20px;

    &:focus-visible {
        outline: 2px solid #000;
        outline-offset: 2px;
    }
`

function StatCard({ title, value, component, suffix = '+', position }) {
    return (
        <CardWrapper>
            <Title>{title}</Title>
            <ValueContainer>
                {component ? component : <Value>{value}</Value>}
                <Suffix style={{ ...position }}>{suffix}</Suffix>
            </ValueContainer>
        </CardWrapper>
    )
}

function AnimationCountWrapper({ count }) {
	const lang = useSelector(state => state.langStore.lang);
    const settings = {
        start: 0,
        count,
        duration: 3000,
        animation: 'up',
        useGroup: true
    }
    return <CountWrapper><AnimationCount {...settings} />{lang === 'ko' && <span>개</span>}</CountWrapper>
}

export default function DeviceSection({ history }) {
	const lang = useSelector(state => state.langStore.lang);
    const slickRef = useRef(null);
    const slickChangeTimeRef = useRef(Date.now());
    const [allFinishedVideosCount, setAllFinishedVideosCount] = useState(0);

    useEffect(() => {
        getTemplateCount();
        const slickAnimationInterval = () => {
            if (slickRef.current) {
                const now = Date.now();
                if (now - slickChangeTimeRef.current >= 1000) {
                    slickRef.current.slickNext();
                    slickChangeTimeRef.current = now;
                }
            }
        };

        const timeoutId = setTimeout(() => {
            const intervalId = setInterval(slickAnimationInterval, 100);
            return () => clearInterval(intervalId);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, []);

    const getTemplateCount = async () => {
        const { result, data } = await TemplateApis.GetAllTemplatesCount()
        if (result) setAllFinishedVideosCount(data);
    }

    const statsData = [
        {
            title: i18n.t("common.landing.stats.data.title_1"),
            value: i18n.t("common.landing.stats.data.value_1"),
            position: { right: '-10px', bottom: '10px' }
        },
        {
            title: i18n.t("common.landing.stats.data.title_2"),
            value: i18n.t("common.landing.stats.data.value_2"),
            position: { right: '-10px', bottom: '10px' }
        },
        {
            title: i18n.t("common.landing.stats.data.title_3"),
            value: i18n.t("common.landing.stats.data.value_3"),
            position: { right: '-10px', bottom: '15px' }
        }
    ]
    const keywords = [
        i18n.t("common.landing.keywords_1"),
        i18n.t("common.landing.keywords_2"),
        i18n.t("common.landing.keywords_3"),
        i18n.t("common.landing.keywords_4"),
        i18n.t("common.landing.keywords_5"),
        i18n.t("common.landing.keywords_6"),
        i18n.t("common.landing.keywords_7"),
        i18n.t("common.landing.keywords_8"),
    ];

    const slickSetting = {
        infinite: true,
        slidesToShow: 1,
        vertical: true,
        verticalSwiping: true
    }

    return (
        <Section>
            <ContentWrapper>
                <Content>
                    <BadgeWrapper>
                        <Badge>{i18n.t("common.landing.device.section.text")}</Badge>
                    </BadgeWrapper>
                    <TitleGroup>
                        <CategoryWrapper>
                            <BracketText>[</BracketText>
                            <SlickWrapper className={lang}>
                                <SlickSlider {...slickSetting} ref={slickRef}>
                                    {keywords.map(keyword => <CategoryText>{keyword}</CategoryText>)}
                                </SlickSlider>
                            </SlickWrapper>
                            <BracketText>]</BracketText>
                            <ServiceTitle>{i18n.t("common.landing.device.section.title")}</ServiceTitle>
                        </CategoryWrapper>
                        <BrandName>{i18n.t("common.landing.top.banner.videomonster")}</BrandName>
                    </TitleGroup>
                    <StatsContainer>
                        <TopStats>
                            {statsData.slice(0, 2).map((stat, index) => (
                                <StatCard key={index} {...stat} />
                            ))}
                        </TopStats>
                        <StatCard
                            {...statsData[2]}
                            component={
                                <AnimationCountWrapper count={allFinishedVideosCount} />
                            }
                        />
                    </StatsContainer>
                </Content>
                <DeviceWrapper>
                    <Video
                        src={`${lang === 'ko' ? `https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/2_smartphone.mp4` : `https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/2_smartphone_en.webm`}`}
                        muted
                        autoPlay
                        loop
                        playsInline
                        webkit-playsinline
                    />
                    <Image loading="lazy" src="https://front.videomonster.com/images-u6yd72dy/common/newlanding2024/device_frame.png" alt="비디오몬스터 서비스 이미지" />
                </DeviceWrapper>
            </ContentWrapper>
            <ButtonContainer>
                <StartButton
                    onClick={() => history.push('/designselect')}
                >
                    {i18n.t("common.landing.device.section.btn")}
                </StartButton>
            </ButtonContainer>
        </Section>
    );
}
